import Vue from 'vue';
import Component from 'vue-class-component';
import ReminderOcassions from 'assets/graphql/queries/ReminderOcassions.graphql';

import Datepicker from 'vuejs-datepicker';
import BbField from 'common/components/BbField';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import Cleave from 'cleave.js';
import compareDayAndMonthWithNow from 'utils/compareDayAndMonthWithNow';

import BbHorizontalSlider from 'common/components/BbHorizontalSlider';

@Component({
  props: {
    stepData: {
      type: Object,
    },
    stepIcon: {
      type: String,
    },
    isLoading: {
      type: Boolean,
    },
  },
  apollo: {
    reminder_occasions: {
      query: ReminderOcassions,
      result({ data }) {
        return data.reminder_occasions;
      },
    },
  },
  components: {
    BbField,
    Datepicker,
    BbHorizontalSlider,
  },
})
export default class StepComponent extends Vue {
  isDissableInputDate = false;
  valueDateAux = this.stepData.date.value || '';
  reminder_occasions = [];
  windowInnerWidth = null

  mounted() {
    this.cleave = new Cleave('#input-date', {
      date: true,
      datePattern: ['d', 'm'],
      blocks: [2, 2],
    });
    dayjs.extend(customParseFormat);
    this.windowInnerWidth = window.innerWidth
  }

  validatingFormBeforeTheNextStep() {
    this.stepData.date.value = compareDayAndMonthWithNow(this.cleave);
    this.valueDateAux = this.cleave.getFormattedValue().slice(0, 5);
    this.stepData.nextStep();
    this.valueDateAux = '';
    this.cleave.setRawValue('');
  }

  handleDissableInputDateByIdOccasion(id) {
    const { date } = this.reminder_occasions.find(oc => oc.id == id);
    const getDayAndMonthOccasionOrEmpty = date
      ? dayjs(date, 'YYYY-MM-DD').format('DD/MM')
      : '';
    this.cleave.setRawValue(getDayAndMonthOccasionOrEmpty);
    this.valueDateAux = getDayAndMonthOccasionOrEmpty;
    this.isDissableInputDate = Boolean(getDayAndMonthOccasionOrEmpty);
  }
}
